import LocationApi from "./LocationApi";

export default LocationApi;